import type { IframeHeight, IframeSandbox } from "../../../shared/schema";

// Height preset mapping (in pixels)
export const heightPresets: Record<Exclude<IframeHeight, number>, string> = {
  sm: "200px",
  md: "400px",
  lg: "600px",
  xl: "800px",
};

// Default sandbox settings for embedded content
export const DEFAULT_IFRAME_SANDBOX: IframeSandbox = {
  allowScripts: true,
  allowSameOrigin: true,
  allowForms: true,
  allowPopups: false,
};

// Build sandbox attribute string from options
export const buildSandboxAttr = (sandbox: IframeSandbox): string => {
  const attrs: string[] = [];
  if (sandbox.allowScripts) attrs.push("allow-scripts");
  if (sandbox.allowSameOrigin) attrs.push("allow-same-origin");
  if (sandbox.allowForms) attrs.push("allow-forms");
  if (sandbox.allowPopups) attrs.push("allow-popups");
  return attrs.join(" ");
};

// Convert height to CSS value
export const getHeightStyle = (height: IframeHeight): string => {
  if (typeof height === "number") {
    return `${height}px`;
  }
  return heightPresets[height] ?? "400px";
};

// Build URL with multiple query parameters
export const buildUrlWithParams = (baseUrl: string, params: Record<string, string>): string | null => {
  try {
    const url = new URL(baseUrl);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    return url.toString();
  } catch {
    return null;
  }
};
